// extracted by mini-css-extract-plugin
module.exports = {"root":"auto-saving-message_root__3h5OH"};